export { AtnReportTableComponent as Component } from './report-table.component'
